<template>
  <div class="order_detail">
    <nav-bar />
    <search-bar />
    <div class="main fz14" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>我的订单</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order_list_item">产品信息</div>
            <div class="center order_list_item">产品规格</div>
            <div class="center order_list_item">设备信息</div>
            <div class="center order_list_item">配套工艺</div>
            <div class="center order_list_item">产品价格</div>
            <div class="center order_list_item">数量</div>
            <div class="center order_list_item">商品价格</div>
          </div>
          <el-divider />
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{ order_detail.create_time }}</span>
                <span class="ml20 grey"
                  >订单编号：{{ order_detail.order_no }}</span
                >
                <span
                  v-html="order_state_decide(order_detail)"
                  class="ml20"
                ></span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <div
                    class="fr jc ac order_left"
                    v-for="(goods, i) in order_detail.orderGoodsBeans"
                    :key="i"
                  >
                    <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                      <el-image
                        class="goods_img fs mr10"
                        :src="goods.goods_img"
                        alt
                      />
                      <div>
                        <p class>
                          {{ goods.goods_name }} {{ goods.goods_standard_name }}
                        </p>
                        <table-column :info="goods" />
                      </div>
                    </div>
                    <div class="center order_list_item">
                      {{ specNameInit(goods) }}
                    </div>
                    <div class="center order_list_item">
                      {{ goods.device_id ? goods.device_id : "-" }}
                    </div>

                    <div
                      v-if="goods.goods_type == 1"
                      @click="onShowSelectCraft(goods)"
                      class="center cursor order_list_item blue"
                    >
                      {{ goods.goods_craft_price }}
                    </div>
                    <div
                      v-if="goods.goods_type == 2"
                      class="center cursor order_list_item blue"
                    >
                      -
                    </div>

                    <div class="center order_list_item">
                      ￥{{ goods.goods_price }}
                    </div>
                    <div class="center order_list_item">
                      {{ goods.goods_num }}
                    </div>
                    <div class="center order_list_item red">
                      ￥{{ goods.goods_actual_price }}
                    </div>
                  </div>
                </div>
              </div>

              <!--                下-->
            </div>
          </div>
        </div>

        <p class="fz16 bold mt20 mb20">订单信息</p>
        <el-form
          label-width="130px"
          size="small"
          label-position="left"
          :disabled="true"
        >
          <el-row>
            <el-col :span="12" class="pr10">
              <el-form-item label="合同类型:">
                <status-tag
                  :value="order_detail.contract_type"
                  :status-map="{
                    1: { type: 'warning', label: '平台合同' },
                    2: { type: 'success', label: '客户合同' },
                  }"
                />
              </el-form-item>
              <el-form-item label="是否免单:">
                <status-tag
                  :value="order_detail.is_sale_free"
                  :status-map="{
                    0: { type: 'warning', label: '否' },
                    1: { type: 'success', label: '是' },
                  }"
                />
              </el-form-item>
              <el-form-item label="是否外贸：">
                <status-tag
                  :value="order_detail.is_foreign_trade"
                  :status-map="{
                    0: { type: 'warning', label: '否' },
                    1: { type: 'success', label: '是' },
                  }"
                />
              </el-form-item>

              <el-form-item label="是否等通知开票：">
                <status-tag
                  :value="order_detail.is_required_invoice_notify"
                  :status-map="{
                    0: { type: 'warning', label: '否' },
                    1: { type: 'success', label: '是' },
                  }"
                />
              </el-form-item>
              <el-form-item label="服务费:">
                {{ order_detail.order_service_price }}
              </el-form-item>
              <el-form-item label="服务内容:">
                {{ order_detail.order_service_remark }}
              </el-form-item>

              <el-form-item label-width="0">
                <span class="black"
                  >实际订单{{ order_detail.delivery_time }}天交货</span
                >
              </el-form-item>

              <el-form-item label-width="0">
                <span class="black"
                  >合同生效{{ order_detail.contract_delivery_time }}天交货</span
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同备注：">
                <pre>{{ order_detail.contract_remarks }}</pre>
              </el-form-item>
              <el-form-item label="其他条款：">
                <pre>{{ order_detail.contract_terms }}</pre>
              </el-form-item>
              <el-form-item
                label="地址备注："
                v-if="!is_Empty(order_detail.orderAddressBean.remarks)"
              >
                <pre>{{ order_detail.orderAddressBean.remarks }}</pre>
              </el-form-item>
              <el-form-item label="订单备注：">
                <pre>{{ order_detail.order_remark }}</pre>
              </el-form-item>
              <el-form-item label="客户内部订单号：">
                {{ order_detail.vip_order_no }}
              </el-form-item>
              <el-form-item label="客户内部备注图片：">
                <up-load
                  disabled
                  :file_list.sync="order_detail.vip_order_imgs"
                  :limit="6"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 22222222222222222222222222222222222222222222222222222222222222 -->
        <div class="price_box">
          <div class="price_item fr ac jsb">
            <span class="black">服务费</span>

            <span class="black">
              <span
                placeholder="请输入服务费"
                style="background-color: #f0f6ff;width: 100px;text-align: right"
                type="text"
                >{{ order_detail.order_service_price }}</span
              >
            </span>
          </div>

          <div class="price_item fr ac jsb mb20">
            <span class="black">订单总价</span>
            <span class="red bold">￥{{ order_detail.order_total_price }}</span>
          </div>

          <div class="price_item fr ac jsb mb20">
            <el-checkbox :value="order_detail.is_invoice == '1'" disabled
              >开具发票</el-checkbox
            >
            <span class="black" v-if="order_detail.is_invoice == '1'">{{
              order_detail.orderInvoiceBean.invoice_id
                ? order_detail.orderInvoiceBean.invoice_name
                : "未选择发票"
            }}</span>
          </div>
          <!-- 付款比例 -->
          <p class="fz16 bold mt20 mb20">付款方式</p>
          <div class="pay_table">
            <div class="tr fr">
              <div class="th fg fs">款到下单(元)</div>
              <div class="th fg fs">款到发货(元)</div>
              <div class="th fg fs">货到付款(元)</div>
            </div>
            <div class="tr fr">
              <div class="td fg fs">
                <span>{{ order_detail.pay_start_price }}</span>
              </div>
              <div class="td fg fs">
                <span>{{ order_detail.pay_ing_price }}</span>
              </div>
              <div class="td fg fs fr ac jc">
                <span>{{ order_detail.pay_end_price }}</span>
                <div class="ml20">
                  <span class="blue">
                    <span>{{ order_detail.pay_day }}</span>
                    天
                  </span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      货到后须多少天内付款
                      <br />例：30天，货到后须在30天内将剩余的60%付齐。
                    </div>

                    <i class="el-icon-warning-outline red"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <el-divider />
          <!-- 收货地址 -->
          <p class="fz16 bold mt20 mb20">收货地址</p>
          <div class="receipt" v-if="order_detail.orderAddressBean">
            <div class="top fr ac">
              <p>{{ order_detail.orderAddressBean.address_name }}</p>
              <p class="ml20">
                {{
                  this.formatPhone(order_detail.orderAddressBean.address_mobile)
                }}
              </p>
            </div>
            <div class="bottom">
              {{ order_detail.orderAddressBean.address_province }}
              {{ order_detail.orderAddressBean.address_city }}
              {{ order_detail.orderAddressBean.address_country }}
              {{ order_detail.orderAddressBean.address_detailed }}
            </div>
          </div>
          <!--          合同类型-->
          <p class="fz16 bold mt20 mb20">合同类型</p>
          <el-select
            disabled
            v-model="order_detail.contract_type"
            placeholder="请选择合同类型"
          >
            <el-option label="平台合同" value="1"></el-option>
            <el-option label="客户合同" value="2"></el-option>
          </el-select>

          <el-divider />
          <!-- 平台合同 -->
          <div class="contract-list">
            <div class="mb20">
              <p class="bold">平台合同</p>
              <up-load
                :file_list.sync="order_detail.contract_platform_imgs"
                :limit="6"
                :disabled="true"
              />
            </div>
            <div class="mb20">
              <p class="bold">客户合同</p>
              <up-load
                :file_list.sync="order_detail.contract_imgs"
                :limit="6"
                :disabled="true"
              />
            </div>
          </div>

          <div
            class="mt20 fr ac jc"
            v-if="
              order_detail.is_required_invoice_notify === 1 &&
                order_detail.is_invoice_notify === 0
            "
          >
            <el-button @click="notifyOrderInvoice">通知开票</el-button>
          </div>
        </div>
      </div>
    </div>
    <footer-bar />

    <!--    弹窗-->
    <!-- 选择配套工艺 -->
    <select-craft
      v-if="!is_Empty(order_detail)"
      :show.sync="crafts_show"
      :select_craft_list.sync="goods_crafts"
      :craft_remark.sync="craft_remark"
      :disabled="true"
    />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";
import StatusTag from "@/components/StatusTag.vue";
export default {
  data() {
    return {
      //工艺弹窗
      crafts_show: false,

      //当前选择的商品id
      current_order_goods_id: "",

      order_detail: {},
      loading: false,
      goods_crafts: [],
      craft_remark: "",
    };
  },
  mounted() {
    this.getOrderDetail();
  },
  methods: {
    notifyOrderInvoice() {
      this.$confirm("您确定要通知财务开票吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.post("orderInterfaces/v1.0/notifyOrderInvoice", {
            order_id: this.$route.query.order_id,
          }).then((res) => {
            this.$message.success("已通知开票！");
            this.getOrderDetail();
          });
        })
        .catch(() => {});
    },
    //显示商品工艺列表
    onShowSelectCraft(goods) {
      this.goods_crafts = goods.orderCraftBeans;
      this.craft_remark = goods.craft_remark;
      this.crafts_show = true;
    },

    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.order_id,
      }).then((res) => {
        let order = res.data;
        this.initConfirmForm(order);

        this.loading = true;
      });
    },

    initConfirmForm(order) {
      order = {
        ...order,
        order_actual_price: order.order_actual_price,
        contract_platform_imgs: this.strToArr(order.contract_platform_imgs),
        contract_imgs: this.strToArr(order.contract_imgs),
        vip_order_imgs: this.strToArr(order.vip_order_imgs),
      };
      this.order_detail = order;
    },
  },
  components: {
    NavBar,
    SearchBar,
    FooterBar,
    "up-load": Upload,
    StatusTag,
  },
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;

      .contract-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
      }

      .info {
        background-color: #fff;

        .order_list_item {
          &:nth-of-type(1) {
            width: 400px;
          }

          &:nth-of-type(2) {
            width: 130px;
          }

          &:nth-of-type(3) {
            width: 130px;
          }

          &:nth-of-type(4) {
            width: 130px;
          }

          &:nth-of-type(5) {
            width: 130px;
          }

          &:nth-of-type(6) {
            width: 130px;
          }

          &:nth-of-type(7) {
            width: 130px;
          }
        }

        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;

            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }

            .middle {
              border-bottom: 1px solid #e5e5e5;

              .order {
                .order_left {
                  border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }

                .operating {
                  p {
                    margin-top: 10px;

                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .el-image {
        width: 100px;
        height: 100px;
      }

      .price_box {
        font-size: 14px;

        .price_item {
          padding: 0 20px;
          min-height: 50px;
          background-color: #f0f6ff;
          border-bottom: 1px solid #fff;

          .vip_order_imgs {
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }

        .pay_table {
          height: 100px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;

              &:last-child {
                border-right: none;
              }
            }

            .td {
              width: 33.33%;
            }
          }
        }

        .contract_img {
          width: 150px;
          height: 150px;
          margin-right: 10px;
        }

        .receipt {
          width: 40%;
          border: 1px solid #e5e5e5;

          .top {
            padding: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .bottom {
            padding: 30px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/salesOrder/detail.vue